import { render, staticRenderFns } from "./DialogSetBalance.vue?vue&type=template&id=6c071500"
import script from "./DialogSetBalance.vue?vue&type=script&lang=ts"
export * from "./DialogSetBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports